import { NgZone } from '@angular/core';
import { Store } from '@ngrx/store';
import { DeviceSyncStatus } from '@rocksoft/apple-sync-sdk';
import { RouteGroupRule } from '@rocksoft/shared';
import { DeviceActiveSyncsStoreActions } from '../sub-features/device-sync/device-active-syncs-store';
import { DeviceSyncStatusActions } from '../sub-features/device-sync/device-sync-statuses-store';

/**
 * Creates route group rules for Apple sync related SignalR hubs
 */
export function createAppleSyncRules(store: Store, zone: NgZone): RouteGroupRule[] {
  return [
    // Active device syncs monitoring (apple-sync hub)
    {
      name: 'active-sync-monitoring-group',
      urlPattern: /^\/devices/,
      hub: 'apple-sync',
      groupName: 'active-sync-monitoring',
      eventHandlers: [
        {
          eventName: 'OnActiveDeviceSyncsRetrieved',
          handler: (currentActiveSyncs: number) => {
            zone.run(() => {
              store.dispatch(
                DeviceActiveSyncsStoreActions.SignalRActions.activeDeviceSyncsUpdated({ currentActiveSyncs })
              );
            });
          },
        },
      ],
    },

    // Devices sync status updates (apple-sync hub)
    {
      name: 'devices-location-sync-group',
      urlPattern: /^\/devices\/brands\/[^/]+\/locations\/[^/]+/, // (/devices/brands/:brandId/locations/:locationId)
      hub: 'apple-sync',
      groupName: `location_devices_syncs`, // TODO: We should listen to CategoryId given by CategoryDeviceSyncStatus when we refactored web to use category ids everywhere #40815.
      eventHandlers: [
        {
          eventName: 'OnDeviceSyncStatusChanged',
          handler: (status: DeviceSyncStatus) => {
            zone.run(() => {
              store.dispatch(DeviceSyncStatusActions.SignalRActions.statusChanged({ status }));
            });
          },
        },
      ],
    },
  ];
}
